import { TextField, useMediaQuery } from '@mui/material';
import React, { useState, useEffect } from 'react';

function TextArea({ name, onChange, newValue,label='Comentario' }) {
  const [value, setValues] = useState(newValue || '');
      const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    setValues(newValue || '');
  }, [newValue]);

  const handleChange = (event) => {
    setValues(event.target.value);
    onChange(name, event.target.value);
  };

  return (
    <div>
      <TextField
        id="outlined-basic"
        label={label}
        variant="outlined"
        multiline
        rows={3}
        fullWidth
        name={name}
        onChange={handleChange}
        value={value}
        sx={{marginBottom:"5px", padding:"5px", width:isMobile ? 200:300,}}
        style={{ resize: 'vertical' }}
      />
    </div>
  );
}

export default TextArea;